export const PREMUIM_APP_GEN_LICENSE = 161;
